<script>
    export default {
        props: ['list', 'name'],
        data() {
            return {
                sortProperty: 'name',
                sortDirection: 'asc',
                filterTerm: '',
                selected: []
            }
        },
        methods: {
            sort(ev, property) {
                ev.preventDefault();
                this.sortProperty = property;
                this.sortDirection = (this.sortDirection === 'asc') ? 'desc' : 'asc';
            },
            selectAll() {
                if (this.selected.length > 0) {
                    this.selected = [];
                } else {
                    for (let obj in this.getList) {
                        this.selected.push(this.list[obj].name);
                    }
                }
            },
        },
        computed: {
            getList: function () {
                return _.orderBy(this.list, this.sortProperty, this.sortDirection)
                    .filter((obj) => {
                        let searchRegex = new RegExp(this.filterTerm, 'i');
                        return searchRegex.test(obj.name);
                    })
            }
        },
        mounted() {
            for (let key in this.list) {
                let cur = this.list[key];
                if (cur.checked) {
                    this.selected.push(cur.name);
                }
            }
        }

    }
</script>